import { mainSiteUrl } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20warm%20cream%20and%20soft%20terracotta%20abstract%20gradient%20background%20with%20delicate%20organic%20flowing%20shapes%2C%20subtle%20product%20display%20silhouettes%20of%20fashion%20items%20floating%20in%20soft%20bokeh%2C%20minimalist%20luxury%20editorial%20style%2C%20italian%20modern%20aesthetic%2C%20warm%20neutral%20beige%20and%20sand%20tones%2C%20airy%20ethereal%20composition%2C%20clean%20sophisticated%20atmosphere&width=1800&height=1200&seq=itaobuy-hero-v2-main&orientation=landscape')`,
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20 py-20 md:py-24">
        <div className="max-w-[680px]">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
            <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
            <span className="text-white/90 text-sm font-medium">Guida Aggiornata 2026</span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Itaobuy Spreadsheet:
            <br />
            La Guida Italiana Completa
            <br />
            per Trovare i Migliori Prodotti
          </h1>

          <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-[540px]">
            Scopri come utilizzare Itaobuy Spreadsheet per trovare prodotti selezionati,
            confrontare informazioni, controllare la qualit&agrave; e acquistare in modo pi&ugrave; intelligente.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-8 py-4 rounded-full bg-white text-primary-600 font-semibold text-base hover:bg-white/95 transition-all cursor-pointer whitespace-nowrap"
            >
              buy it now
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <button
              onClick={() => { navigate('/articolo-guida-itaobuy-spreadsheet'); window.scrollTo(0, 0); }}
              className="flex items-center gap-2 px-8 py-4 rounded-full bg-white/10 backdrop-blur-sm border border-white/25 text-white font-semibold text-base hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
            >
              Come Funziona Itaobuy
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 mt-12">
            {['Guida aggiornata 2026', 'Informazioni in italiano', 'Analisi categorie prodotti', 'Consigli sicurezza'].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-white/75 text-sm">
                <i className="ri-check-line text-accent-400"></i>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <button
          onClick={() => document.getElementById('guida')?.scrollIntoView({ behavior: 'smooth' })}
          className="flex flex-col items-center gap-1 text-white/50 hover:text-white/80 transition-colors cursor-pointer"
        >
          <span className="text-xs">Scopri di pi&ugrave;</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </button>
      </div>
    </section>
  );
}